///<reference path="../../employee/sections/employee.location.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class LocationSection extends Meevo.Plugins.Employee.LocationSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherUserSecurity;
        }

    }
}